export const isPhone = (value: string) => {
  if (!/^\d{10,11}$/.test(value)) return false;
  const ddd = parseInt(value.substring(0, 2), 10);
  if (ddd < 11 || ddd > 99) return false;
  if (value.length === 11 && value[2] !== '9') return false;
  return true;
};
